module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAZlBMVEUAAAB2kfpyjvp2kfp1kfp2kft2kft1kft1kPtyjfN1kfp1kfp1kfp1kfpwj/h1kfp1kfp1kft1kfp1j/h0j/d1jfl2jPhfhfZ1kfp2kfp1kfh0kfl0kfl1kPp0kfp2kPtzjPJ2kfryxx5rAAAAIXRSTlMA5jX32aqRfl4P0sm6jCHvwK+GRj4cFwbfmWZWTZ+ecxQxG829AAAAq0lEQVQY043Q2Q6DIBCFYQdFFgW3ulTtMu//kj1gTGtjmv5X+jGQQPJXJtffNLQVuyP5W8rM8pNGBUI1vtvGdXFnASgUc4YfSURNn4wWdvUl8wQsCGVewXJBjMkdqSfMiXhoCayDWY8JLIRy4D1geWEWkmMrcA4oLwyP0QgcMmAtuGs23G65ACeTPtP9xNhqiYTrAlWP98ssuTa6snI2yTGtTh6yPUMnkp+9AEd1DlfNRQexAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/DeYuPingJia_2.png
// module id = hts5
// module chunks = 57